import { User } from "firebase/auth"
import { SpaceKey } from "popopo-msg"
import { useForm } from "react-hook-form"
import React from "react"
import { api, firestore } from "../../core"
import { usePublicSpaceBGMsForAdmin } from "popopo-lib-front/firestore-access"

type SpaceBGMUpdateForms = {
  deleteBGM: boolean
  backgroundMusicId: string
  volume: string
}

export const SpaceBGMUpdateForm = (props: { firebase: User; spaceKey: SpaceKey; bgmConfiguration: { defaultBGMId: string; defaultVolume: string } | null }) => {
  const spaceBGMs = usePublicSpaceBGMsForAdmin(firestore)
  const form = useForm<SpaceBGMUpdateForms>({
    mode: "onBlur",
    defaultValues: {
      deleteBGM: !props.bgmConfiguration,
      backgroundMusicId: props.bgmConfiguration ? props.bgmConfiguration.defaultBGMId : "",
      volume: props.bgmConfiguration ? props.bgmConfiguration.defaultVolume : "0",
    },
  })
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (value: SpaceBGMUpdateForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.PUT("/api/v2/spaces/{space_key}/bgm", {
        params: { path: { space_key: props.spaceKey } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          bgm: value.deleteBGM
            ? {
              id: "",
              kind: "shared",
              volume: parseFloat(value.volume),
            }
            : {
              id: value.backgroundMusicId,
              kind: "shared",
              volume: parseFloat(value.volume),
            },
        },
      })
    } catch (e) {
      console.error(e)
    }
  }
  return (
    <>
      <form className="d-flex flex-column gap-3 w-100" onSubmit={form.handleSubmit(onSubmit)}>
        <div className="form-check">
          <input id="bgm-not-set-check" type="checkbox" className="form-check-input" {...form.register("deleteBGM")}></input>
          <label className="form-check-label" htmlFor="bgm-not-set-check">
            BGMを設定しない
          </label>
        </div>
        <div className={form.watch("deleteBGM") ? "d-none" : ""}>
          {spaceBGMs !== "loading" ? (
            <select
              className="form-select"
              {...form.register("backgroundMusicId", {
                validate: (id) => form.watch("deleteBGM") || !!id,
                onChange: () => {
                  const bgm = spaceBGMs.filter((x) => x.id === form.getValues("backgroundMusicId"))[0]
                  if (bgm) {
                    form.setValue("volume", bgm.default_volume.toString(10))
                  }
                },
              })}
            >
              {spaceBGMs.map((bgm) => (
                <option key={bgm.id} value={bgm.id}>
                  {bgm.name}
                </option>
              ))}
            </select>
          ) : (
            <p>BGM情報を読込中</p>
          )}
          <label>BGM</label>
          <div className="form-floating">
            <input type="number" step="1" className="form-control" min={0} max={100} {...form.register("volume")} disabled={isSubmitting} />
            <label>Volume</label>
          </div>
        </div>

        <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
          Call &quot;PUT /spaces/:spaceKey/background-music&quot; API
        </button>
      </form>
    </>
  )
}
